import { AxiosResponse } from "axios";
import {
    AdvisorsLinkedToClientsResult,
    ClientAdvisoryLinksResult,
    RegistrationReportsRequest,
    RegistrationReportsRespone,
    ScorecardReportRequest
} from "../../Model/Dto/Advisory/Employee";
import { axiosCoreInstance } from "../AxiosCoreInterceptor";
import * as ApiUrls from "./ApiUrl.Advisory";
import { ClientRegistrationSearchRequest, ClientRegistrationSearchResults } from "../../Model/Dto/Advisory/ClientRegistration";
import { ClientScorecardSearchRequest, ClientScorecardSearchResults } from "../../Model/Dto/Advisory/ClientScorecard";

export const AdvisoryService = {
    getLinkedBEE123Employees: (userId: string, role: string):
        Promise<AxiosResponse<ClientAdvisoryLinksResult>> => axiosCoreInstance.get(`${ApiUrls.GetLinkedBEE123Employees}?userId=${userId}&role=${role}`),
    
    getClientAdvisorLinks: ():
        Promise<AxiosResponse<AdvisorsLinkedToClientsResult[]>> => axiosCoreInstance.get(ApiUrls.AdvisoryClient),

    updateClientAdvisorLinks: (advisors: AdvisorsLinkedToClientsResult[]):
        Promise<AxiosResponse<AdvisorsLinkedToClientsResult[]>> => axiosCoreInstance.put(ApiUrls.AdvisoryClient, advisors),
        
    createScorecardReport: (scorecardReport: ScorecardReportRequest):
        Promise<AxiosResponse<number>> => axiosCoreInstance.post(ApiUrls.CreateScorecardReport, scorecardReport),

    searchClientRegistrations: (input: ClientRegistrationSearchRequest):
        Promise<AxiosResponse<ClientRegistrationSearchResults>> => axiosCoreInstance.post(ApiUrls.SearchClientRegistrations, input),

    searchRegistrationReports: (input: RegistrationReportsRequest):
        Promise<AxiosResponse<RegistrationReportsRespone>> => axiosCoreInstance.post(ApiUrls.SearchScorecardReports, input),

    searchClientScorecards: (registrationId: string, input: ClientScorecardSearchRequest): 
        Promise<AxiosResponse<ClientScorecardSearchResults>> => axiosCoreInstance.post(`${ApiUrls.SearchClientScorecards}?registrationId=${registrationId}`, input)  
}